import { ErrorOutline } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  ScopedCssBaseline,
  Stack,
  Typography,
} from '@mui/material';

export type PlanningWarning = {
  readonly id: string;
  readonly title: string;
  readonly message: string;
};

type PlanningWarningDialogProps = {
  readonly open: boolean;
  readonly warnings: PlanningWarning[];
  readonly onApprove: () => void | Promise<void>;
  readonly onCancel: () => void;
  readonly loading?: boolean;
  readonly approveButtonLabel?: string;
  readonly questionText?: string;
};

export const PlanningWarningDialog = ({
  open,
  warnings,
  onApprove,
  onCancel,
  loading = false,
  approveButtonLabel = 'Speichern',
  questionText = 'Möchtest du trotzdem speichern?',
}: PlanningWarningDialogProps) => (
  <Dialog
    open={open}
    onClose={onCancel}
    slotProps={{ paper: { sx: { p: 1.5, borderRadius: '16px', zIndex: (theme) => theme.zIndex.modal + 1 } } }}
  >
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <ErrorOutline sx={{ color: 'warning.main' }} />
      <Typography variant="headingXs">Warnungen zur aktuellen Planung</Typography>
    </DialogTitle>
    <DialogContent>
      <ScopedCssBaseline>
        <Stack>
          {warnings.map((warning) => (
            <Paper
              key={warning.id}
              sx={{
                p: 2,
                border: '1px solid',
                borderColor: 'warning.main',
                borderRadius: '8px',
              }}
            >
              <Typography variant="headingXxs">{warning.title}</Typography>
              <Typography variant="paragraph" sx={{ display: 'block', mt: 1 }}>
                {warning.message}
              </Typography>
            </Paper>
          ))}

          <Typography sx={{ mt: 2 }}>{questionText}</Typography>
        </Stack>
      </ScopedCssBaseline>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} type="button" autoFocus variant="outlined" size="small">
        Abbrechen
      </Button>
      <Button
        onClick={() => void onApprove()}
        disabled={loading}
        loading={loading}
        type="button"
        color="primary"
        variant="contained"
        size="small"
      >
        {approveButtonLabel}
      </Button>
    </DialogActions>
  </Dialog>
);
